/** 名大祭デモ用ルート（develop 環境のみ。本番相当の機能セットでログなし体験） */
export const MEIDAISAI_PREFIX = '/meidaisai';

export function isMeidaisaiRoute(pathname = '') {
  return pathname === MEIDAISAI_PREFIX || pathname.startsWith(`${MEIDAISAI_PREFIX}/`);
}

export function getRouteBase(pathname = '') {
  return isMeidaisaiRoute(pathname) ? MEIDAISAI_PREFIX : '';
}

/** 本番 .env.production と同じ機能セット */
export function getMeidaisaiFeatureFlags() {
  return {
    prediction: false,
    aiCorner: false,
    english: false,
    tvDemo: false,
    admin: false,
    meidaisai: true,
  };
}
